import { postWithToken, getWithToken } from "./api.js";

const DCS_URL = process.env.VUE_APP_BACKEND_URL.match(/\/$/)
  ? process.env.VUE_APP_BACKEND_URL
  : `${process.env.VUE_APP_BACKEND_URL}/`;

function createDcsClient(token) {
  return {
    get(path) {
      return getWithToken(`${DCS_URL}${path}`, token);
    },
    post(path, data) {
      return postWithToken(`${DCS_URL}${path}`, data, token);
    }
  };
}

export default createDcsClient;
